// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1__9j","cls2":"ResearcherList-cls2_Kx1 ResearcherList-cls1__9j"};